var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepBackward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23858 2.23858 0 5 0H19C21.7614 0 24 2.23858 24 5V19C24 21.7614 21.7614 24 19 24H5C2.23858 24 0 21.7614 0 19V5Z",
    fill: "#none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7498 17.75C16.6513 17.7505 16.5536 17.7312 16.4626 17.6935C16.3716 17.6557 16.2891 17.6001 16.2198 17.53L11.2198 12.53C11.0794 12.3894 11.0005 12.1987 11.0005 12C11.0005 11.8012 11.0794 11.6106 11.2198 11.47L16.2198 6.47C16.362 6.33752 16.55 6.2654 16.7444 6.26882C16.9387 6.27225 17.124 6.35096 17.2614 6.48838C17.3989 6.62579 17.4776 6.81118 17.481 7.00548C17.4844 7.19978 17.4123 7.38782 17.2798 7.53L12.8098 12L17.2798 16.47C17.4203 16.6106 17.4992 16.8012 17.4992 17C17.4992 17.1987 17.4203 17.3894 17.2798 17.53C17.2106 17.6001 17.128 17.6557 17.037 17.6935C16.946 17.7312 16.8484 17.7505 16.7498 17.75Z",
    fill: "#0A0A0A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 19C6.55189 18.9977 6.36263 18.9255 6.22253 18.799C6.08244 18.6725 6.00259 18.5015 6 18.3226V5.67742C6 5.49776 6.07902 5.32545 6.21967 5.19841C6.36032 5.07137 6.55109 5 6.75 5C6.94891 5 7.13968 5.07137 7.28033 5.19841C7.42098 5.32545 7.5 5.49776 7.5 5.67742V18.3226C7.49741 18.5015 7.41756 18.6725 7.27747 18.799C7.13737 18.9255 6.94811 18.9977 6.75 19Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepBackward);
export default __webpack_public_path__ + "static/media/step-backward.773bbf592252c855b112e198d2ef1b0a.svg";
export { ForwardRef as ReactComponent };